import React from 'react';
import { DateTime } from 'luxon';
import { Button } from "react-bootstrap";
import { useSelector } from "react-redux";
import { RootState } from "app/store";
import Constants, { ASAP, DateFormat } from "app/shared/constants/constants";
import { formatDateLabel, formatTimeLabel } from 'app/shared/utils/utilityFunctions';

interface Props {
  className: string,
  onClick: () => void,
}

const PickupScheduleButton: React.FC<Props> = ({
  className,
  onClick,
}) => {
  const { pickUpType, pickUpTime, pickUpDate} = useSelector((state: RootState) => state.stores);
  let formatedDate;
  let formatedTime;

  if (!pickUpDate.includes('now')) {
    formatedDate = formatDateLabel(DateTime.fromFormat(pickUpDate.replaceAll('UTC', '').trim(), DateFormat.yyyy_MM_dd_HH_mm_ss).toFormat(DateFormat.YYYY_MM_DD));
    formatedTime = formatTimeLabel(DateTime.fromFormat(pickUpDate.replaceAll('UTC', '').trim(), DateFormat.yyyy_MM_dd_HH_mm_ss).toFormat(DateFormat.HH_mm));
  }

  const shouldBeDisabled = (
     pickUpType === "" || pickUpTime === "" || pickUpTime === Constants.NO_PICKUP_TIME || pickUpType === Constants.NO_PICKUP_TYPE
  );
  const displayPickupDateTime = `${(formatedDate && formatedTime && !pickUpTime.includes(ASAP))
    ? ' / '.concat(formatedDate).concat(' ').concat(formatedTime)
    : ' / '.concat(pickUpTime)}`;

  const diplayText = `${pickUpType} ${displayPickupDateTime}`;

  return (
    <Button
      disabled={shouldBeDisabled}
      aria-label={`${diplayText} click to change the pick up time`}
      type="button"
          className={className}
          onClick={onClick}
    >
          <p className="font-sub">
            {diplayText}
          </p>
    </Button>
  );
};

export default PickupScheduleButton;
